// const fs = require("fs");
// const path = require("path");
const validator = require('gltf-validator');
// const axios = require('axios');
// const unzipit = require('unzipit');

export async function validateGltfFromZip(entries) {
    try {
        // // Download the ZIP file
        // const response = await axios({
        //     url: zipUrl,
        //     method: 'GET',
        //     responseType: 'arraybuffer'
        // });

        // // Unzip the contents using unzipit
        // const { entries } = await unzipit.unzip(response.data);
        
        // Find the .gltf file in the zip entries
        const gltfEntry = Object.values(entries).find(entry => entry.name.endsWith('.gltf'));
        if (!gltfEntry) {
            throw new Error('No .gltf file found in the ZIP archive.');
        }

        // Read the content of the .gltf file
        const gltfContent = await gltfEntry.arrayBuffer();
        const gltfAsset = new Uint8Array(gltfContent);

        // Validate the .gltf file
        const result = await validator.validateBytes(gltfAsset, {
            uri: gltfEntry.name,
            maxIssues: 10,
            ignoredIssues: ['UNSUPPORTED_EXTENSION'],
            severityOverrides: { 'ACCESSOR_INDEX_TRIANGLE_DEGENERATE': 0 },
            externalResourceFunction: async (uri) => {
                const resourceEntry = entries[uri];
                if (!resourceEntry) {
                    throw new Error(`Resource ${uri} not found in the ZIP archive.`);
                }
                return new Uint8Array(await resourceEntry.arrayBuffer());
            }
        });

        console.log("GLTF Validation result :",JSON.stringify(result, null, '  '));
        if(result.issues.numErrors === 0){
          return true;
        }
        else
          return false;

    } catch (error) {
        console.error('GLTF Validation Error:', error);
        return false;
    }
}